import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getObjectNamesByType } from '@api';

export const getCoreDataDictionaryObjectNamesAsyncSlice = createGetAsyncSlice({
	httpSagaOptions: {
		cache: true
	},
	name: 'CoreDataDictionaryObjectNames',
	receive: true,
	request: true,
	requestHandler: getObjectNamesByType
});
